module.exports = "/_next/static/images/9cca90e97c3d4b1837d4abceea2d4712-boy-looking-to-the-front@0.75x.jpg";